<template>
  <section class="visitor-info">
    <div class="visitor-info__container">
      <c-headline class="mb-sm">
        {{ $t('title') }}
      </c-headline>

      <div
        class="visitor-info__introduction"
        v-html="$t('introduction')"
      />
    </div>

    <div
      v-if="IS_IE"
      class="visitor-info__container"
      v-html="$t('ieMessage')"
    />

    <template v-else>
      <div class="visitor-info__container">
        <c-headline
          class="mb-sm"
          level="2"
        >
          {{ $t('sectionTitle') }}
        </c-headline>
      </div>

      <c-gift-cards-selection />
    </template>
  </section>
</template>

<script>
import CGiftCardsSelection from './CGiftCardsSelection.vue'
import CHeadline from './headline.vue'

import { IS_IE } from '../settings.js'

export default {
  name: 'CGiftCardsBody',

  components: {
    CGiftCardsSelection,
    CHeadline
  },

  computed: {
    IS_IE: () => IS_IE
  }
}
</script>

<i18n locale="de">
{
  "title": "Geschenkgutscheine",
  "introduction": "<p>Hier erhalten Sie Gutscheine, die Sie direkt zu Hause ausdrucken und verschenken können. Inhaber von Geschenkgutscheinen erhalten nach Reservierung eines Termins VIP-Einlass ohne Wartezeit.</p><p>Hardtickets, die bequem zu Ihnen nach Hause geschickt werden, können Sie weiterhin im <a href=\"https://shop.miniatur-wunderland.de/tickets-gutscheine.html\" target=\"_blank\">Onlineshop</a> bestellen.</p>",
  "sectionTitle": "Gutscheindaten"
}
</i18n>

<i18n locale="en">
{
  "title": "Gift Vouchers",
  "introduction": "<p>Here you can purchase gift vouchers, which you print at home and give away. Owners of gift vouchers receive VIP-admittance after making a reservation.</p><p>Hardtickets, that are being sent comfortably to your home, can still be purchased in our <a href=\"https://shop.miniatur-wunderland.com/tickets-gift-vouchers.html\" target=\"_blank\">onlineshop</a>.</p>",
  "sectionTitle": "Gift card info"
}
</i18n>
